<template>
  <div class="param-error-mask">
    <div class="error-container">
      <h2 class="error-title">参数错误</h2>
      <p class="error-message">缺少必要的参数，请检查URL是否包含以下参数：</p>
      <div class="param-list">
        <span class="param-item">company_id</span>
        <span class="param-item">cost_center_id</span>
        <span class="param-item">screen_id</span>
      </div>
      <p class="error-example">示例：http://example.com/?company_id=123&cost_center_id=456&screen_id=1</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParamError',
  props: {
    show: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.param-error-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.error-container {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border-radius: 20px;
  padding: 40px 60px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.error-title {
  color: #fff;
  font-size: 28px;
  margin-bottom: 15px;
  font-weight: 600;
}

.error-message {
  color: #aaa;
  font-size: 16px;
  margin-bottom: 20px;
}

.param-list {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 20px;
}

.param-item {
  background: rgba(231, 76, 60, 0.2);
  color: #e74c3c;
  padding: 8px 20px;
  border-radius: 25px;
  font-family: monospace;
  font-size: 14px;
}

.error-example {
  color: #666;
  font-size: 13px;
  font-family: monospace;
}
</style>